<script setup lang="ts">
  import GenericDialog from '@/components/dialog/GenericDialog.vue'
  import { useImportWarnings } from '@/composables/useImportWarnings'
  import type { ImportErrors } from '@/composables/useGIDataSpeckleImport'

  const store = useGIDataUploadCollectionStore()

  const { warningGroups } = useImportWarnings(() => store.importWarnings as ImportErrors)
</script>

<template>
  <GenericDialog
    :model-value="store.importWarningsDialog"
    :max-width="600"
    @update:model-value="store.closeImportWarnings()"
    @clicked-outside="store.closeImportWarnings()"
  >
    <template #title> Import completed with warnings </template>
    <template #default>
      <p>Some locations were skipped during import:</p>

      <div v-for="group in warningGroups" :key="group.code" class="mt-3">
        <p class="mb-1">{{ group.summary }}</p>
        <p class="ml-6 mb-0" style="max-height: 30vh; overflow-y: auto">
          {{ group.detail }}
        </p>
      </div>

      <p class="mt-3">Fix the issues in OpenGround and import again.</p>
    </template>
    <template #actions>
      <v-btn variant="text" color="primary" @click="store.closeImportWarnings()"> Close </v-btn>
    </template>
  </GenericDialog>
</template>
